import axios from "axios";
import { API_TOKEN, API_URL } from "common/config";

const api = axios.create({
  baseURL: API_URL,
  headers: {
    Authorization: `Bearer ${API_TOKEN}`,
  },
  withCredentials: true,
});

export default api;
